<template>
  <label class="b-checkbox checkbox check unselectable">
    <input
        type="checkbox"
        v-model="isSelected"/>
    <span class="check"/>
    <span class="control-label"><slot/></span>
    {{ label }}
  </label>
</template>

<script>

export default {
  name: 'CheckboxCustom',
  props: ['value', 'label'],
  data() {
    return {
      isSelected: this.value ? this.value : false
    };
  },
  watch: {
    isSelected() {
      this.$emit('input', this.isSelected);
    }
  }
}
</script>